var _excluded = ["children", "buttonText", "buttonSkin", "buttonVariant", "buttonSize", "buttonDisabled", "buttonIcon", "buttonCustomIcon", "buttonShape", "isFluid", "menuPosition", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component, useEffect, useState } from 'react';
import { string, oneOf, node, bool, oneOfType, element } from 'prop-types';
import classNames from 'classnames';
import './Dropdown.scss';
import DropdownToggle from './DropdownToggle';
import DropdownMenu from './DropdownMenu';
import uuid from 'uuid';
var propTypes = {
  children: node,

  /** Add your own custom class names to the component */
  className: string,

  /** Button text */
  buttonText: string.isRequired,

  /** Choose between these variants: */
  buttonVariant: oneOf(['filled', 'outline', 'flat']),

  /** Choose between these skins: */
  buttonSkin: oneOf(['dark', 'light', 'success', 'danger', 'info']),

  /** Choose between these sizes: */
  buttonSize: oneOf(['small', 'medium', 'large']),

  /** Choose between these shapes: */
  buttonShape: oneOf(['rounded', 'pill']),

  /** Makes the dropdown fill the parents available space */
  isFluid: bool,

  /** Make the button disabled */
  buttonDisabled: bool,

  /** Place icon before text.*/
  buttonIcon: element,

  /** Place custom icon before text. */
  buttonCustomIcon: string,

  /** Controls position of the Dropdown menu */
  menuPosition: string
};
var defaultProps = {};
/**
 * The Dropdown is a packaged and toggleable component that can include a DropdownItem, DropdownHeader and DropdownDivider.
 * @description In development
 * */

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      buttonText = _ref.buttonText,
      buttonSkin = _ref.buttonSkin,
      buttonVariant = _ref.buttonVariant,
      buttonSize = _ref.buttonSize,
      buttonDisabled = _ref.buttonDisabled,
      buttonIcon = _ref.buttonIcon,
      buttonCustomIcon = _ref.buttonCustomIcon,
      buttonShape = _ref.buttonShape,
      isFluid = _ref.isFluid,
      menuPosition = _ref.menuPosition,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState("rds-dropdown-toggle-".concat(uuid.v4())),
      _useState4 = _slicedToArray(_useState3, 2),
      toggleId = _useState4[0],
      setToggleId = _useState4[1];

  var _useState5 = useState("rds-dropdown-".concat(uuid.v4())),
      _useState6 = _slicedToArray(_useState5, 2),
      componentId = _useState6[0],
      setComponentId = _useState6[1];

  var ESC_KEY = 27;

  var onOutsideClickHandler = function onOutsideClickHandler(e) {
    var dropdownWrapper = document.getElementById(componentId);
    var targetElement = e.target;

    do {
      if (targetElement === dropdownWrapper) {
        return;
      }

      targetElement = targetElement.parentNode;
    } while (targetElement);

    setVisible(false);
  };

  useEffect(function () {
    document.body.addEventListener('click', onOutsideClickHandler, false);
    return function () {
      document.body.removeEventListener('click', onOutsideClickHandler, false);
    };
  });

  var _onClick = function onClick(e) {
    setVisible(!visible);
  };

  var onItemListClick = function onItemListClick(e) {
    setVisible(false);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === ESC_KEY) {
      setVisible(false);
    }
  };

  var componentClassNames = classNames('rds-dropdown', {
    'rds-is-fluid': isFluid
  }, className);
  var menuClassNames = classNames('rds-dropdown__menu', {
    'rds-is-right': menuPosition === 'right',
    'rds-is-fluid': isFluid
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: componentClassNames,
    id: componentId,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    }
  }, rest), /*#__PURE__*/React.createElement(DropdownToggle, {
    text: buttonText,
    skin: buttonSkin,
    variant: buttonVariant,
    size: buttonSize,
    shape: buttonShape,
    isFluid: isFluid,
    disabled: buttonDisabled,
    iconLeft: buttonIcon,
    customIconLeft: buttonCustomIcon,
    onClick: function onClick(e) {
      return _onClick(e);
    },
    expanded: visible,
    id: toggleId
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    className: menuClassNames,
    show: visible,
    "aria-labelledby": toggleId,
    onClick: function onClick(e) {
      return onItemListClick(e);
    }
  }, children));
};

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
export default Dropdown;